<template>
  <div class="top-nav">
    <div>
      <global-campus />
    </div>
    <div class="right">
      <el-popover placement="bottom" title="" :width="430" trigger="hover">
        <template #reference>
          <div class="task-center">
            <svg class="icon" style="margin-right: 5px;">
              <use xlink:href="#icon-tablet"></use>
            </svg>
            <span>移动端</span>
          </div>
        </template>
        <template #default>
          <div style="display: flex; gap: 16px; flex-direction: column">
            <div class="mobile-title">校管家云校支持移动端下载App，或关注公众号使用。</div>
            <div class="mobile-content">
              <div class="mobile-item">
                <img class="mobile-img" src="../assets/images/xiaogj_yunxiao_app.png" />
                <span class="memo-name">下载APP</span>
                <span class="memo">独立APP，体验更佳</span>
              </div>
              <div class="line"></div>
              <div class="mobile-item">
                <img class="mobile-img-special" src="../assets/images/xiaogj_yunxiao_gzh.png" />
                <span class="memo-name-special">关注公众号</span>
                <span class="memo">无需下载，微信公众号消息直达</span>
              </div>
            </div>
          </div>
        </template>
      </el-popover>

      <el-popover placement="bottom" ref="czczd" title="" popper-class="czczd" trigger="manual" :width="900"
        :visible="visible">
        <template #reference>
          <div class="task-center" @click="triggerTask">
            <svg class="icon">
              <use xlink:href="#icon-detail"></use>
            </svg>
            <span>任务中心</span>
          </div>
        </template>
        <template #default>
          <el-tabs v-model="activeName">
            <el-tab-pane label="数据导出" name="first"></el-tab-pane>
            <el-tab-pane label="数据导入" name="second"></el-tab-pane>
          </el-tabs>
          <div class="refresh" @click="refresh">
            <el-icon class="el-icon-refresh-left">
            </el-icon>
          </div>
          <div class="task-center-table" v-if="visible">
            <component ref="componentzd" :is="currentTabComponent"></component>
          </div>
        </template>
      </el-popover>
      <!-- <div class="task-center" @click="openTaskPopup()">
        <svg class="icon" style="margin-right: 5px">
          <use xlink:href="#icon-detail"></use>
        </svg>
        <span>任务中心</span>
      </div> -->
      <!-- <div class="my-service" @click="getService">
        <svg class="icon" style="margin-right: 10px">
          <use xlink:href="#icon-customerservice"></use>
        </svg>
        <span>我的客服</span>
      </div> -->
      <el-dropdown @command="handleSysHelp">
        <div class="my-service">
          <svg class="icon" style="margin-right: 5px">
            <use xlink:href="#icon-setting"></use>
          </svg>
          <span style="margin-right: 5px;">系统帮助</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="a">
              <svg class="icon-sys-down-ques" style="margin-right: 5px; margin-left: -1px;">
                <use xlink:href="#icon-bangzhuzhongxin"></use>
              </svg>
              <span>帮助中心</span>
            </el-dropdown-item>
            <el-dropdown-item command="b">
              <svg class="icon-sys-down" style="margin-right: 5px">
                <use xlink:href="#icon-customerservice"></use>
              </svg>
              <span>在线客服</span>
            </el-dropdown-item>
            <el-dropdown-item command="c">
              <svg class="icon-sys-down" style="margin-right: 5px">
                <use xlink:href="#icon-guanfangjiaoliuqu"></use>
              </svg>
              <span>官方交流区</span>
            </el-dropdown-item>
            <el-dropdown-item command="d">
              <svg class="icon-sys-down-ques" style="margin-right: 5px">
                <use xlink:href="#icon-jishuzhichi"></use>
              </svg>
              <span>技术支持授权</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <!-- <div class="help">
        <span style="cursor: pointer;color: var(--g4);">
                <svg class="icon"><use xlink:href="#icon-question-circle" /></svg>
              </span>
        帮助
      </div>
      <div class="theme">
        <el-dropdown @command="handleCommand">
          <span>
            <i class="el-icon-bell"></i>
            更换主题
          </span>
          <template #dropdown>
            <el-dropdown-menu class="theme-dropdown">
              <el-dropdown-item command="default">
                <div class="sign">
                  <span class="title color-default">拂晓蓝</span>
                  <i class="el-icon-check" v-if="curTheme == 'default'"></i>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="1">
                <div class="sign">
                  <span class="title color-1">薄暮</span>
                  <i class="el-icon-check" v-if="curTheme == '1'"></i>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div> -->
      <el-dropdown popper-class="info-popper">
        <div class="info">
          <img :src="user.photo?.url" class="avatar" />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <template #dropdown>
          <el-dropdown-menu class="info-dropdown">
            <div class="avatar-container">
              <img :src="user.photo?.url" class="avatar" />
              <div>{{ user.name }}</div>
            </div>
            <el-dropdown-item class="dropdown-custom">
              <!-- <div class="company">
                <div class="ellipsis">{{ user.companyInfoVo.companyName }}</div>
                <span class="change" v-if="companyList.length > 1" @click="changeCompany"
                  >切换</span
                >
              </div> -->
              <div @click="changeCompany" class="company">
                <div class="ellipsis">
                  <svg class="icon" style="margin-right: 10px">
                    <use xlink:href="#icon-flag"></use>
                  </svg>
                  {{ user.companyInfoVo.companyName }}
                </div>
                <i class="el-icon-arrow-right" v-if="companyList.length > 1"></i>
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="dropdown-custom">
              <div @click="$router.push('/my-info')">
                <svg class="icon" style="margin-right: 10px">
                  <use xlink:href="#icon-user"></use>
                </svg>
                个人信息
              </div>
            </el-dropdown-item>
            <el-dropdown-item @click="transfer" v-if="op('_superAdmin')" class="dropdown-custom">
              <div>
                <svg class="icon" style="margin-right: 10px">
                  <use xlink:href="#icon-switchuser"></use>
                </svg>
                转让超级管理员
              </div>
            </el-dropdown-item>
            <el-dropdown-item @click="logout" class="dropdown-custom">
              <div>
                <svg class="icon" style="margin-right: 10px">
                  <use xlink:href="#icon-export"></use>
                </svg>
                退出登录
              </div>
            </el-dropdown-item>
            <!-- <div class="version-container">当前版本：V3.51</div> -->
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { inject, ref, computed, onMounted } from 'vue';
import GlobalCampus from '@teacher/components/global-campus/global-campus.vue';
import { ElNotification } from 'element-plus';
import events from '@teacher/config/event-type';
import exportData from '../views/common/task-center/comps/export.vue';
import importData from '../views/common/task-center/comps/import.vue';

export default {
  props: {},
  setup(props) {
    const visible = ref(false);
    const czczd = ref(null);
    const hidePopover = (e) => {
      if (!['<use xlink:href="#icon-detail" data-v-45eaadf3=""></use>', '任务中心'].includes(e.target.innerHTML) &&
        visible.value && czczd.value.popperRef.contentRef.outerHTML.indexOf(e.target.outerHTML) === -1) {
        visible.value = false;
      }
    };
    onMounted(() => {
      document.addEventListener('click', hidePopover);
    });
    const triggerTask = () => {
      visible.value = !visible.value;
    };
    // 切换主题
    // const route = useRoute();
    const componentzd = ref();
    const type = props.type || 'first';
    const activeName = ref(type);
    const currentTabComponent = computed(() => {
      switch (activeName.value) {
        case 'first':
          return exportData;
        case 'second':
          return importData;
        default:
          return exportData;
      }
    });
    const refresh = () => {
      componentzd.value.queryList(true);
    };
    const app = inject('app');
    const curTheme = ref(app.css.getTheme());
    const { on } = inject('useEvent')();

    function handleCommand(command) {
      app.css.themeChange(command, true);
      curTheme.value = command;
    }
    const $message = inject('$message');
    // 登出
    const lib = inject('lib');
    function logout() {
      lib.logout();
    }

    // 转让管理员
    const store = inject('store');
    // const { user } = store;
    const { user } = store;
    const popup = inject('popup');
    const api = inject('api');
    function transfer() {
      popup('transfer-manager', {
        transferorId: user.value.id,
      }).then(() => {
        // 触发任意接口401
        api.businessLogin();
      });
    }

    // 获取升级通知
    async function getNotice() {
      const res = await api.getNotice();
      if (res.data) {
        let message = `<span>${res.data.content}</span>`;
        if (res.data.url) {
          message += `<br/><a href="${res.data.url}" style="color:var(--primary); cursor: pointer;" target="_blank">点击查看</a>`;
        }
        ElNotification({
          // title: '通知公告',
          dangerouslyUseHTMLString: true,
          message,
          duration: 15000,
        });
      }
    }
    getNotice();
    // 获取即将过期通知
    async function getExpireNotice() {
      const res = await api.getExpireNotice();
      if (res.data) {
        const message = `<span>${res.data.content}</span>`;
        // const message = `<span>${res.msg}</span>`;
        ElNotification({
          dangerouslyUseHTMLString: true,
          message,
          duration: 0,
          onClose: async () => {
            await api.closeExpireNotice();
          },
        });
      }
    }
    getExpireNotice();
    const sendGa4 = (name) => {
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        gtag('event', 'x3-pc-event-menu', {
          x3_web_env: process.env.VUE_APP_x3_env,
          x3_pc_bunisess_type: 'x3-PC-老师端',
          x3_client_type: app.tool.getBrowserType(),
          x3_company_name: store.user.value.companyInfoVo.companyName,
          x3_nav_menu_name: name,
          x3_page_alias: `云校-header-${name}`,
          x3_page_path: '_blank',
        });
      }, 301);
    };
    function getService() {
      const realname = user.value.name;
      const partnerid = user.value.id;
      const uname = `云校-${user.value.companyInfoVo.companyName}`;
      const tel = user.value.phone;
      sendGa4('我的客服');
      // eslint-disable-next-line max-len
      const kefuUrl = `https://xiaogj.sobot.com/chat/h5/v6/index.html?sysnum=2b52e6f7a8f0461cb188501e07b63bfd&channelid=4&realname=${realname}&partnerid=${partnerid}&uname=${uname}&tel=${tel}&groupid=d643054d3fd24933932718b9313e7b0e`;
      window.open(kefuUrl, '_blank');
    }
    const openTaskPopup = (types) => {
      // 1. $router.push('/task-center')
      // 2. popup('task-popup-common-zd', {
      //   type: types || 'first',
      // })
      //   .then()
      //   .catch(() => { });
      $message.success(`${types === 'first' ? '导出' : '导入'}成功，请前往【任务中心】查看`);
    };
    on(events.openTaskCenterpopup, openTaskPopup);
    // 获取机构列表
    const { companyList } = store;
    return {
      componentzd,
      triggerTask,
      activeName,
      currentTabComponent,
      refresh,
      visible,
      openTaskPopup,
      handleCommand,
      curTheme,
      logout,
      transfer,
      czczd,
      user,
      companyList,
      async changeCompany() {
        if (companyList.value.length > 1) {
          popup('company-change');
        }
      },
      sendGa4,
      handleSysHelp(cmd) {
        switch (cmd) {
          case 'a':
            window.open('https://bangzhu.xiaogj.com/', '_blank');
            break;
          case 'b':
            getService();
            break;
          case 'c':
            window.open('https://txc.qq.com/products/615113', '_blank');
            break;
          case 'd':
            popup('sys-authorization', {
              title: '技术支持授权',
            });
            break;
          default:
            break;
        }
      },
    };
  },
  components: {
    GlobalCampus,
  },
};
</script>

<style lang="scss" scoped>
.refresh {
  position: absolute;
  top: 20px;
  right: 16px;
  font-size: 17px;
  cursor: pointer;
  color: var(--g3);
}

.task-center-table {
  background-color: var(--white);
  min-height: auto;
  border-radius: 16px;
  overflow: hidden;
}

.bread-crumb-custom {
  font-size: var(--fs-md);
  font-weight: 400;
}

.top-nav {
  height: 100%;
  // background: var(--white);
  overflow: hidden;
  // border-bottom: 1px solid var(--g5);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  color: var(--g1);
  background-color: white;
  font-size: var(--fs-md);
  line-height: var(--lh-md);

  .right {
    display: flex;
    cursor: pointer;
    align-items: center;

    .help {
      margin-right: 25px;
    }

    .theme {
      margin-right: 25px;
    }

    .info {
      display: flex;
      align-items: center;

      .avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
    .task-center,
    .my-service {
      margin-right: 40px;
      color: var(--g2);
      display: flex;
      align-items: center;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.mobile-title {
  text-align: center;
  color: #2C2F35;
  font-size: 14px;
}

.mobile-content {
  display: flex;

  .line {
    height: 100px;
    margin-top: 4px;
    width: 1px;
    border-left: 1px solid #eceef2;
  }

  .mobile-item {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .mobile-img {
      width: 108px;
      height: 108px;
      object-fit: cover;
    }

    .mobile-img-special {
      width: 121px;
      height: 121px;
      margin-top: -4px;
      object-fit: cover;
    }

    .memo-name-special {
      font-size: 14px;
      color: #2C2F35;
    }

    .memo-name {
      font-size: 14px;
      color: #2C2F35;
      margin-top: 8px;
    }

    .memo {
      font-size: 12px;
      color: #909399;
      margin-top: 8px;

    }
  }
}

.theme-dropdown {
  .sign {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 120px;

    .title::before {
      content: '';
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      margin-right: 8px;
    }

    .color-default::before {
      background-color: #2284fe;
    }

    .color-1::before {
      background-color: #f5084f;
    }
  }
}

.info-popper {
  border-radius: 16px !important;
  overflow: hidden;
}

.info-dropdown {
  width: 220px;
  border-radius: 16px !important;
  padding: 0 !important;

  .dropdown-custom {
    height: 40px;
    line-height: 40px;
    padding-right: 8px;
  }

  .avatar-container {
    padding: 18px 16px;
    height: 80px;
    display: flex;
    align-items: center;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--white);
    background: url(https://cdn01.xiaogj.com/uploads/x3/assets/pc/img/teacher/info-bg.png) no-repeat;
    background-size: cover;

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 15px;
      border: 1px solid var(--white);
    }
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .company {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .version-container {
    margin: 0 12px;
    padding-left: 6px;
    height: 36px;
    display: flex;
    align-items: center;
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g3);
    border-top: 1px solid var(--g6);
  }
}

.icon-sys-down {
  width: 16px;
  height: 16px;
  fill: #666;
}

.icon-sys-down-ques {
  width: 18px;
  height: 18px;
}
</style>
